import * as UsersAPI from 'remote/users'
import { dataFetched } from 'data/graphql'

import { selectors as UserPreferencesSelectors } from 'data/userPreferences'

export const goToUserOnboardingStep = ({ step }) => ({
  dispatch,
  graphQLClient,
}) => ({
  type: 'GO_TO_USER_ONBOARDING_STEP',
  payload: {
    promise: graphQLClient
      .mutate({
        query: UsersAPI.goToUserOnboardingStep,
        variables: { step },
      })
      .then(({ data }) => {
        dispatch(dataFetched(data.goToUserOnboardingStep))
      }),
  },
})

export const skipUserOnboarding = () => ({ dispatch, graphQLClient }) => ({
  type: 'SKIP_USER_ONBOARDING',
  payload: {
    promise: graphQLClient
      .mutate({
        query: UsersAPI.skipUserOnboarding,
      })
      .then(({ data }) => {
        dispatch(dataFetched(data.skipUserOnboarding))
      }),
  },
})

export const goToAppropriateUserOnboardingStep = () => ({
  getState,
  dispatch,
}) => {
  const state = getState()
  const userPreferences = UserPreferencesSelectors.getUserPreferences(state)
  const onboardingStep = userPreferences.onboardingStep

  if (onboardingStep !== 'done') {
    // Display popover sequence for everyone - only once
    dispatch(goToUserOnboardingStep({ step: 'channels' }))
  }
}
